var map = {
	"./button-big-bg.png": "0350",
	"./card1.jpg": "16e1",
	"./card1_new.jpg": "3623",
	"./card1_new_decor.png": "69e8",
	"./card3.jpg": "5392",
	"./la-logo.png": "8899",
	"./no-presents.jpg": "fc63",
	"./prizes/chest.png": "69d5",
	"./prizes/new/pic-2.png": "f771",
	"./prizes/new/pic.png": "f2e7",
	"./prizes/old/pic-1-new.png": "aeeb",
	"./prizes/old/pic-1.png": "ffa8",
	"./prizes/old/pic-2-new.png": "eb77",
	"./prizes/old/pic-2.png": "0a75",
	"./prizes/old/pic-3.png": "3965",
	"./prizes/old/pic-4.png": "3c8f",
	"./prizes/old/pic-5.png": "5378",
	"./prizes/old/pic-new.png": "ad34",
	"./prizes/old/pic.png": "aab3",
	"./promo-bg.jpg": "0f19",
	"./separator.svg": "20f6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";